import { z } from 'zod';

import { zodRejectionFileRoleSchema } from '../useMutationRejectInvoice/validations';

export const zodInvoiceEmailSuggestionKindSchema = z.enum([
  'rejection',
  'credit_note_request',
  'reduction_notice',
]);

export const zodInvoiceEmailSuggestionResponseSchema = z.object({
  cc: z.array(z.string()),
  fileRoles: z.array(zodRejectionFileRoleSchema),
  message: z.string().nullable(),
  subject: z.string(),
  to: z.array(z.string()),
  userFileIds: z.array(z.uuid()),
});

export const zodInvoiceEmailSuggestionEndpointSchema = z.tuple([
  z.literal('invoices'),
  z.uuid(),
  z.literal('email_suggestions'),
  zodInvoiceEmailSuggestionKindSchema,
]);
